import { render, staticRenderFns } from "./ManageDictionaryRow.vue?vue&type=template&id=240e7515&scoped=true&"
import script from "./ManageDictionaryRow.vue?vue&type=script&lang=js&"
export * from "./ManageDictionaryRow.vue?vue&type=script&lang=js&"
import style0 from "./ManageDictionaryRow.vue?vue&type=style&index=0&id=240e7515&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e7515",
  null
  
)

export default component.exports